import { MealType } from '@akin-home/amplify';
import { toDateString } from '@akin-home/dates';
import { eachDayOfInterval, endOfWeek, isSameDay } from 'date-fns';
import {
  findBreakfastMeal,
  findDinnerMeal,
  findLunchMeal,
  findSnackMeal,
} from '.';
import { Meal } from '../types';

interface Params {
  meals: Meal[];

  week_start_date: Date;

  meal_type_filter?: Record<MealType, boolean>;
}

export const groupMealsIntoWeekPlan = (params: Params) => {
  const { meals, week_start_date, meal_type_filter } = params;

  const dates = eachDayOfInterval({
    start: week_start_date,
    end: endOfWeek(week_start_date),
  });

  return dates.map((day) => {
    const meals_for_day = meals.filter((meal) => isSameDay(meal.start, day));

    return {
      date: toDateString(day),
      meals: {
        Breakfast:
          meal_type_filter?.Breakfast === false
            ? undefined
            : findBreakfastMeal(meals_for_day),
        Lunch:
          meal_type_filter?.Lunch === false
            ? undefined
            : findLunchMeal(meals_for_day),
        Dinner:
          meal_type_filter?.Dinner === false
            ? undefined
            : findDinnerMeal(meals_for_day),
        Snack:
          meal_type_filter?.Snack === false
            ? undefined
            : findSnackMeal(meals_for_day),
      },
    };
  });
};
